import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { FooterContainer, Total } from './styled'
import { Button } from 'featureSliced/entities/Button'
import { GridDiv } from 'featureSliced/shared/utils/gridDiv'
import { useGetProductPrice } from 'featureSliced/shared/hooks/useGetProductPrice/indexT'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { convertToPrice } from 'featureSliced/shared/utils/convertToPrice'
import { FC } from 'react'
import { PaymentSteps } from './types'

type FooterProps = {
  step: PaymentSteps
  onConfirmClick: () => void
  isButtonDisabled?: boolean
  isLoading?: boolean
}

export const Footer: FC<FooterProps> = ({
  step,
  onConfirmClick,
  isButtonDisabled = false,
  isLoading = false,
}) => {
  const t = useTranslations()
  const { getAllProductsPrice } = useGetProductPrice()
  const cartProducts = useMySelector((state) => state.bucket.products)
  const currency = useMySelector((state) => state.app.companyData.Currency)

  const getResultPrice = () => {
    const total = getAllProductsPrice(cartProducts)
    return `${convertToPrice(total)} ${currency || ''}`
  }

  return (
    <FooterContainer>
      <Total>
        <span>{t('common.total')}:</span>
        <span>{getResultPrice()}</span>
      </Total>
      <GridDiv gc="1/-1">
        <Button
          buttonType="common"
          width="100%"
          onClick={onConfirmClick}
          disabled={isButtonDisabled}
          isLoading={isLoading}
        >
          {/* TODO: translations */}
          {step === PaymentSteps.OVEWVIEW
            ? t('buttons.continueToCheckout')
            : t('auth.confirmButton')}
        </Button>
      </GridDiv>
    </FooterContainer>
  )
}
